import { useEffect } from 'react';
import { useLanguage } from "../../context/Language/LanguageContext";
import { getRotationLabels } from "../utils/Constants";

function MultiChoice({ filter, handleOptionChanged, compact = false }) {

    const { t } = useLanguage();

    const displayName = (name) => {
        if (filter.title === "Rotations") {
            const labels = getRotationLabels();
            const idx = parseInt(name, 10) - 1;
            if (idx >= 0 && idx < labels.length) {
                return labels[idx];
            }
        }
        // t() falls back to the key itself when untranslated, so this is a
        // no-op for non-phrase item names (player names, zone numbers, grade
        // symbols, ...) and only takes effect for phrase-like item names.
        return t(name).toUpperCase();
    };

    // const [_, forceUpdate] = useReducer((x) => x + 1, 0)

    const toggleAllOptionsSelect = () => {
        var checked = 0
        for (var i = 0; i < filter.items.length; i++) {
            var item = filter.items[i]
            checked += item.selected ? 1 : 0
        }
        if (checked == filter.items.length) {
            filter.allselected = false
            for (var i = 0; i < filter.items.length; i++) {
                var item = filter.items[i]
                item.selected = false
            }
        }
        else {
            filter.allselected = true
            for (var i = 0; i < filter.items.length; i++) {
                var item = filter.items[i]
                item.selected = true
            }
        }
        // console.log('toggleAll checked', checked, filter)
        // forceUpdate()
        handleOptionChanged(filter, null)
    }

    const selectAll = () => {
        filter.allselected = true
        for (var i = 0; i < filter.items.length; i++) {
            var item = filter.items[i]
            item.selected = true
        }
        handleOptionChanged(filter, null)
    }

    const selectNone = () => {
        filter.allselected = false
        for (var i = 0; i < filter.items.length; i++) {
            var item = filter.items[i]
            item.selected = false
        }
        handleOptionChanged(filter, null)
    }

    const selectServes = () => {
        filter.allselected = false
        for (var i = 0; i < filter.items.length; i++) {
            var item = filter.items[i]
            item.selected = (i >= 0 && i < 4)
        }
        handleOptionChanged(filter, null)
    }

    const selectReturns = () => {
        filter.allselected = false
        for (var i = 0; i < filter.items.length; i++) {
            var item = filter.items[i]
            item.selected = (i > 3 && i <= 7)
        }
        handleOptionChanged(filter, null)
    }

    const toggleOptionSelect = (item) => {
        if (filter.singleSelection)
        {
            item.selected = true
            filter.selectedValues = [item.name]
            for (var i = 0; i < filter.items.length; i++) {
                var xitem = filter.items[i]
                if (xitem !== item)
                {
                    xitem.selected = false
                }
            }
        }
        else
        {
            item.selected = !item.selected
            // console.log('Item, Option', item, filter)
            filter.selectedValues = []
            var checked = 0
            for (var i = 0; i < filter.items.length; i++) {
                var item = filter.items[i]
                checked += item.selected ? 1 : 0
                if (item.selected)
                {
                    filter.selectedValues.push(item.name)
                }
            }
            filter.allselected = (checked === filter.items.length)
        }
        handleOptionChanged(filter, item)
    }

    useEffect(() => {
        // console.log(filter);
    }, [filter]);

    if (filter.items === undefined)
    {
        return <></>
    }

    // console.log('MultiChoice', filter)
    return (
        <div>
            <div className={compact ? "options-list-item pl-1" : "options-list-item pb-1 pl-1"}>
                {
                    filter.singleSelection === false ?
                    <div className="flex flex-col">
                    <div className={compact ? "flex space-x-2" : "flex space-x-4"}>
                        <button className={compact ? "flex btn btn-xs rounded-none" : "flex btn btn-sm rounded-none"} onClick={() => selectAll()}>{compact ? t("All") : t("Select All")}</button>
                        <button className={compact ? "flex btn btn-xs rounded-none" : "flex btn btn-sm rounded-none"} onClick={() => selectNone()}>{compact ? t("None") : t("Select None")}</button>
                    </div>
                    {
                        filter.title == "Shots" ?
                            <div className="flex space-x-4 pt-1">
                                <button className="flex btn btn-sm rounded-none" onClick={() => selectServes()}>{t("All Serves")}</button>
                                <button className="flex btn btn-sm rounded-none" onClick={() => selectReturns()}>{t("All Returns")}</button>
                            </div> : null
                    }
                    </div> :
                    <div></div>
                }
            </div>
            <ul className="px-2">
                {filter.items.map((item, index) => {
                    return (
                        <li key={index}>
                            <div className="options-list-item pb-1">
                                <div className="left-section">
                                    <input
                                        key={Math.random()}
                                        type="checkbox"
                                        id={`custom-checkbox-${filter.title}-${item.name}`}
                                        name={item.name}
                                        value={item.name}
                                        checked={item.selected}
                                        onChange={() => toggleOptionSelect(item)}
                                    />
                                    <label className='text-base-content text-xs ml-2' htmlFor={`custom-checkbox-${filter.title}-${item.name}`}>{displayName(item.name)}</label>
                                </div>
                                <div className="right-section text-red-700 text-xs">{item.amount > 0 ? item.amount : ""}</div>
                            </div>
                        </li>
                    );
                })}
                <li>
                    <div className="options-list-item">
                        {/* <div className="left-section">Total:</div>
                        <div className="right-section">{10}</div> */}
                    </div>
                </li>
            </ul>
        </div>
    )
}

export default MultiChoice